"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoftwareVersion = exports.Role = exports.ModGeneration = exports.DevicePlatform = exports.EnrollmentStatus = void 0;
var EnrollmentStatus;
(function (EnrollmentStatus) {
    EnrollmentStatus["NOT_STARTED"] = "NOT_STARTED";
    EnrollmentStatus["STARTED"] = "STARTED";
    EnrollmentStatus["COMPLETED"] = "COMPLETED";
    EnrollmentStatus["INACTIVE"] = "INACTIVE";
    EnrollmentStatus["UNKNOWN"] = "UNKNOWN";
})(EnrollmentStatus || (exports.EnrollmentStatus = EnrollmentStatus = {}));
var DevicePlatform;
(function (DevicePlatform) {
    DevicePlatform["MBB"] = "MBB";
    DevicePlatform["MBB_ODP"] = "MBB_ODP";
    DevicePlatform["WCAR"] = "WCAR";
    DevicePlatform["UNKNOWN"] = "UNKNOWN";
})(DevicePlatform || (exports.DevicePlatform = DevicePlatform = {}));
var ModGeneration;
(function (ModGeneration) {
    ModGeneration["MOD1"] = "MOD1";
    ModGeneration["MOD2"] = "MOD2";
    ModGeneration["MOD2_5"] = "MOD2.5";
    ModGeneration["MOD3"] = "MOD3";
    ModGeneration["MOD3_1"] = "MOD3.1";
    ModGeneration["MOD3_1_UNECE"] = "MOD3.1UNECE";
    ModGeneration["MOD3_2"] = "MOD3.2";
    ModGeneration["MOD3_2_UNECE"] = "MOD3.2UNECE";
    ModGeneration["MOD3_5"] = "MOD3.5";
    ModGeneration["MOD4"] = "MOD4";
    ModGeneration["MOD4_1"] = "MOD4.1";
    ModGeneration["MOD4_2"] = "MOD4.2";
    ModGeneration["MOD5"] = "MOD5";
    ModGeneration["MOD6"] = "MOD6";
    ModGeneration["NA"] = "NA";
    ModGeneration["UNKNOWN"] = "UNKNOWN";
})(ModGeneration || (exports.ModGeneration = ModGeneration = {}));
var Role;
(function (Role) {
    Role["PRIMARY_USER"] = "PRIMARY_USER";
    Role["SECONDARY_USER"] = "SECONDARY_USER";
    Role["GUEST_USER"] = "GUEST_USER";
    Role["ANONYMOUS_USER"] = "ANONYMOUS_USER";
    Role["UNKNOWN"] = "UNKNOWN";
})(Role || (exports.Role = Role = {}));
var SoftwareVersion;
(function (SoftwareVersion) {
    SoftwareVersion["ME0"] = "ME0";
    SoftwareVersion["ME1"] = "ME1";
    SoftwareVersion["ME2"] = "ME2";
    SoftwareVersion["UNKNOWN"] = "UNKNOWN";
})(SoftwareVersion || (exports.SoftwareVersion = SoftwareVersion = {}));
//# sourceMappingURL=types.js.map